module.exports = __webpack_public_path__ + "media/sofia/sofia-footer-949b18d8.png";